import React from 'react';

import { openNoFrame } from './setRoutes';
import { pages } from './activePages';

export const PageRouter = ({ pageProps }) => {
  const orderedRoutes = [
    ...Object.values(pages).map(({ isProtected, mainFrame, ...page }) => {
      return openNoFrame({
        ...page,
        pageProps,
      });
    }),
  ];
  return <>{orderedRoutes}</>;
};
